import { colorSet } from '@components/Provider';
import { Theme } from '@material-ui/core';
import {
  CSSProperties,
  CreateCSSProperties
} from '@material-ui/core/styles/withStyles';
import {
  CHAT_BYPASS_WARNING_BAR,
  CHAT_BYPASS_WARNING_BAR_MOBILE,
  CHAT_INPUT_TOTAL_HEIGHT,
  CHAT_MOBILE_TOTAL_INPUT_HEIGHT
} from '../constants';

type StyleSheetType = CSSProperties | CreateCSSProperties<{}>;

const ChatMessageStyleSheet = (
  isMobile: string,
  theme: Theme
): StyleSheetType => {
  return {
    display: 'flex',
    flexDirection: 'column-reverse',
    height: `calc(100% - ${CHAT_INPUT_TOTAL_HEIGHT}px)`,
    overflow: 'scroll',
    [isMobile]: {
      height: `calc(100%  - ${CHAT_MOBILE_TOTAL_INPUT_HEIGHT}px)`
    },
    '&.bypass-warning': {
      height: `calc(100% - ${
        CHAT_INPUT_TOTAL_HEIGHT + CHAT_BYPASS_WARNING_BAR
      }px)`,
      [isMobile]: {
        height: `calc(100%  - ${
          CHAT_MOBILE_TOTAL_INPUT_HEIGHT + CHAT_BYPASS_WARNING_BAR
        }px)`
      },
      [theme.breakpoints.down('xs')]: {
        height: `calc(100%  - ${
          CHAT_MOBILE_TOTAL_INPUT_HEIGHT + CHAT_BYPASS_WARNING_BAR_MOBILE
        }px)`
      }
    },
    '& > #message': {
      marginBottom: 20,
      [isMobile]: {
        marginBottom: 18
      }
    },
    '& .queue-container': {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      padding: '0px 16px',
      '& > div': {
        marginBottom: 16
      }
    },
    '& .queue-item': {
      width: '100%',
      maxWidth: 230,
      padding: '16px',
      backgroundColor: colorSet.gray000,
      borderRadius: 10,
      '& .queue-file-name': {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        position: 'relative',
        '& .name': {
          width: 158,
          marginRight: 8,
          wordBreak: 'break-all'
        }
      },
      '&.image': {
        padding: 0,
        backgroundColor: 'transparent',
        position: 'relative',
        '& .bg-img': {
          borderRadius: 10,
          width: 230,
          height: 164,
          backgroundPosition: 'center center',
          '&.overlay': {
            position: 'absolute',
            backgroundColor: colorSet.gray1000,
            opacity: 0.3,
            top: 0
          }
        },
        '& .floating': {
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          top: 0,
          width: '100%',
          height: '100%',
          '& .textWhtie': {
            color: colorSet.gray000,
            '&.uploading': {
              marginTop: 8,
              marginBottom: 2
            }
          }
        }
      }
    },
    '& .queue-cta': {
      display: 'flex',
      '& .abort': {
        cursor: 'pointer'
      }
    },
    '& .loading': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%'
    }
  };
};

export default ChatMessageStyleSheet;
